const goldenRatio = 1.61803398875;

export const inverseGoldenRatio = 100 / goldenRatio;
export const doubleInverseGoldenRatio = inverseGoldenRatio / goldenRatio;

export default goldenRatio;
